/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorThumbBoxTextSX: SxProps = {
	justifyContent: 'center',
	border: `1px dashed white`,
	'&:not(:last-child)': {
		borderRightWidth: 0,
	},
};
